import React from "react";
import { Badge } from "react-bootstrap";
import "./SystemCard.css";

const SystemCard = ({ system }) => {
  const getStatusBadge = (active) => {
    if (active) {
      return <Badge bg="success" className="badge-white-text">Activo</Badge>;
    }
    else {
      return <Badge bg="warning" className="badge-white-text">Deshabilitado</Badge>;
    }
  };

  const handleOpen = () => {
    if (system.status !== "maintenance") {
      window.open(system.link, "_blank");
    }
  };

  return (
    <div key={system.id} className="system-card-wrapper">
      <div className="card h-100 shadow-sm border-0 system-card">
        <div className="card-header system-card-header-wrapper border-0 pb-2">
          <div className="system-card-header">
            <div className="system-card-title me-2">
              <h5 className="system-card-name">{system.nombre}</h5>
            </div>
            {getStatusBadge(system.active)}
          </div>
        </div>
        <div className="card-body pt-0 d-flex flex-column">
          <p className="system-card-description">{system.descripcion}</p>
          <button
            className={`btn w-100 mt-auto ${
              !system.active
                ? "btn-secondary disabled"
                : "btn-primary"
            }`}
            onClick={handleOpen}
            disabled={!system.active}
          >
            <>
              Abrir Sistema
              <i className="bi bi-box-arrow-up-right ms-2"></i>
            </>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SystemCard;
